var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TimeConstants, LookupListTypes } from '@logz-pkg/enums';
import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { AccountModel } from '../account/account';
import { alertModelManipulator } from '../alert/alert.manipulator';
import { ElasticsearchFilterModel } from '../elasticsearch/elasticsearch-filter';
import { StaticLookupListModel } from './static-lookup-list';
class ElasticQuery {
    query = '*';
    groupBy = [];
    shouldQueryOnAllAccounts = true;
    accountsToQueryOn = [];
    filters = [];
}
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", Array)
], ElasticQuery.prototype, "groupBy", void 0);
__decorate([
    Type(() => AccountModel),
    Expose({ name: 'accountIdsToQueryOn' }),
    Transform((accounts) => accounts.map(account => account.id), { toPlainOnly: true }),
    __metadata("design:type", Array)
], ElasticQuery.prototype, "accountsToQueryOn", void 0);
__decorate([
    Type(() => ElasticsearchFilterModel),
    Transform((_, query) => alertModelManipulator.convertFiltersToElastic(query), { toPlainOnly: true }),
    Transform((value) => alertModelManipulator.convertElasticToFilters(value), { toClassOnly: true }),
    __metadata("design:type", Array)
], ElasticQuery.prototype, "filters", void 0);
export class LookupListModel extends StaticLookupListModel {
    type = LookupListTypes.STATIC;
    searchQuery;
    timeframeToRunQueryOn = 12 * TimeConstants.SecondsInHour;
    resultsFieldToPickFrom;
    updateInterval = '12 0 * * * * ?';
    constructor(type = LookupListTypes.STATIC) {
        super();
        if (type === LookupListTypes.DYNAMIC) {
            this.searchQuery = new ElasticQuery();
            this.updateInterval = `0 ${Math.floor(Math.random() * 24)} * * * ?`;
            this.type = LookupListTypes.DYNAMIC;
        }
    }
}
__decorate([
    Type(() => ElasticQuery),
    __metadata("design:type", ElasticQuery)
], LookupListModel.prototype, "searchQuery", void 0);
//# sourceMappingURL=lookup-list.js.map